import localize from '~layers/utils/localize.ts'

export function useStrapiCms(
  documentId: string,
  status: string = 'PUBLISHED',
  query: string = 'page',
  alias: string = '',
  locale: string = '',
) {
  const { public: config } = useRuntimeConfig()
  locale = locale || config.strapiLocale
  const originalStrapiData = ref<T | null>()
  const strapiError = ref<Error | null | undefined>(null)

  async function getStrapiData() {
    const { data: response } = await useAsyncGraphqlQuery(query, {
      documentId,
      locale,
      status,
    }, useGraphqlDefaultClient())

    originalStrapiData.value = alias ? response?.value?.data?.[alias] : response?.value?.data

    if (response?.value?.errors?.length) {
      strapiError.value = response.value.errors
      console.error('getStrapiData', response.value.errors)
    }
  }

  const strapiData = computed(() => localize(originalStrapiData.value))

  return {
    getStrapiData,
    strapiData,
    strapiError,
  }
}
